<template>
    <div
        class="base-modal"
        :class="{
            'base-modal--white': white,
            'base-modal--with-footer': $slots.footer,
        }"
        v-bind="$attrs"
    >
        <BaseHeader :title="title" @close="$emit('close')" />

        <div class="l-padded base-modal__content">
            <slot />
        </div>

        <footer v-if="$slots.footer" class="l-padded base-modal__actions">
            <slot name="footer" />
        </footer>
    </div>
</template>

<script>
import BaseHeader from './BaseHeader'

export default {
    name: 'BaseModal',
    components: {
        BaseHeader,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        white: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="scss" scoped>
.base-modal {
    $self: &;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: $color-gray-lighter-new;
    overflow-y: auto;

    &__content {
        flex: 1 0 auto;
    }

    &__actions {
        position: absolute;
        bottom: 0;
        width: 100%;
        border-top: 1px solid $color-gray-light-new;
        background-color: #fff;
        font-size: 14px;
    }

    &--white {
        background-color: #fff;
    }

    &--with-footer {
        #{$self}__content {
            margin-bottom: 68px;
        }
    }
}
</style>
